<!-- eslint-disable max-lines -->
<template>
    <paper  class="mip-iframe">
        <div class="goal-manage-detail"
            v-loading="detailLoading">
            <!-- 标题区域 -->
            <div class="header-box">
                <h4>年目标变更流程</h4>
                <div class="header-part">
                    <div class="apply-info">
                        <div>模板：{{ detailDataLocal.applicantName }}</div>
                        <div>申请人：{{ detailDataLocal.applicantName }}</div>
                        <div>部门：{{ detailDataLocal.applicantDepartName }}</div>
                    </div>
                </div>
            </div>
            <!-- 按钮区域 -->
            <div class="detail-toolBar">
                <lots-button type="primary" v-show="goalManageShow['saveBtn']"
                    :loading="saveLoading"
                    @click="handleSave">保存
                </lots-button>
            </div>
            <!-- 表单区域 -->
            <collapse-infos
                ref="upholdHealder"
                :detailData="detailDataLocal"
                :collapse="COLLAPSE"
                :activeCollapses="activeCollapses"
               >
                <template v-slot:collapse-append="{form, itemSetting, rIndex, collapseItem, dictData}">
                    <div class="file-infos" v-if="itemSetting.prop === 'changeFile'">
                        <div class="upload-box">
                        <lots-upload-button :text="'上传附件'" :bucket="'annto-lcrm'" :disabled="!goalManageShow['saveBtn']"
                                    @callback="(data) => { upLoadData(form, itemSetting, data); }">
                                </lots-upload-button>
                        </div>
                        <template v-if="detailDataLocal.changeFile && detailDataLocal.changeFile.length">
                            <div
                                class="file-list"
                                v-for="(item, index) in detailDataLocal.changeFile"
                                :key="index + item.fileName">
                                <div
                                    class="file-name upload"
                                    :title="item.fileName">
                                    {{`${index+1}. `}}
                                    <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
                                </div>
                                <div class="delete-btn">
                                        <el-button
                                            type="text"
                                            plain
                                            @click="handlePreview(item)">
                                            预览
                                        </el-button>
                                    <el-button
                                        type="text"
                                        plain>
                                        <a :href="item.fileUrl" target="_blank">下载</a>
                                    </el-button>
                                    <el-button
                                        type="text"
                                        plain
                                        @click="handleDeleteFile(form, itemSetting, index)"
                                        :disabled="!goalManageShow['saveBtn']">删除</el-button>
                                </div>
                            </div>
                        </template>
                    </div>
                    <el-table
                        v-else-if="itemSetting.prop === 'detailList'"
                        :data="goalChangeList"
                        style="width: 100%;max-width: 1100px;"
                        border
                        :height="tableHeight">
                        <el-table-column
                            v-for="(col, cIndex) in itemSetting.columns"
                            :key="col.prop + cIndex"
                            :prop="col.prop"
                            :label="col.label"
                            :show-overflow-tooltip="lodash.get(col, 'showTooltip', true)"
                            v-bind="{ ...col, type: lodash.get(col, 'columnType', '') }">
                            <template v-slot="{ row, $index: rIndex }">
                                <div v-if="col.type === 'select'">
                                    <span v-if="dictData[col.optionsKey] && row[col.prop]">{{ dictData[col.optionsKey][row[col.prop]] || row[col.prop] ||'' }}</span>
                                </div>
                                <div v-else>{{ row[col.prop] || '' }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{(form[itemSetting.prop]) ? form[itemSetting.prop] : '--'}}
                    </span>
                </template>
            </collapse-infos>
            <!-- iflow区域 -->
            <el-collapse
                v-if="detailDataLocal.mipFlowId"
                class="contract-collapse detail-more-collapse"
                value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <lots-button
                            size="mini"
                            type="primary"
                            @click="submitMip"
                            :loading="btnloading">
                            mip提交
                        </lots-button>
                    </div>
                    <iframe
                        v-if="!btnloading"
                        class="ifr"
                        id="myIframe"
                        ref="iframeRef"
                        :src="mipUrl" />
                </el-collapse-item>
            </el-collapse>
        </div>

    </paper>
</template>

<script>
import { ref, computed, getCurrentInstance, onActivated, onMounted } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import {
    getGoalChangeInfo, saveGoalManageForm
} from '@mdm/api/opportunityModules/goalManage.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message } from 'element-ui';
import store from '@/store/index';
import { collapse } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import { filePreview } from '@/utils/filePreview.js';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
// import { getFlowInfoApi } from '../../../../utils/flowUtils.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
export default {
    name: 'opportunityApplication',
    components: { paper, lotsButton, CollapseInfos, lotsUploadButton },
    props: {
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => {}
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const detailDataLocal = ref({
            applicantName: '',
            applicantDepartName: ''
        });
        const activeCollapses = ref(['changeInfo', 'detailInfo', 'mipInfo']);
        const mipUrl = ref('');
        const goalChangeList = ref([]);
        const lodash = computed(() => { return _; });
        const COLLAPSE = computed(() => { // 配置项动态计算
            return config;
        });
        const goalManageShow = computed(() => {
            return {
                'saveBtn': ['1', '5', '6'].includes(detailDataLocal.value.approvalStatus?.toString()) // 未生成变更单、未提交审批
            };
        });
        const tableHeight = computed(() => {
            return '350px';
            // return goalChangeList.value.length * MAGIC_NUMBER.FOURTY + MAGIC_NUMBER.FIFTY_ONE + 7 + 'px';
        });
        const currentAuth = ref(false);
        const initQueryData = ref({});
        const { orgName, userName, userCode } = store.getters.user;
        // eslint-disable-next-line complexity
        const _initData = async (id) => {
            const orgArr = orgName.split('_');
            detailDataLocal.value.applicantDepartName = orgArr[orgArr.length - 2];
            detailDataLocal.value.applicant = userCode;
            detailDataLocal.value.applicantName = userName;
            const { workflowId } = ctx.$route.query;
            detailLoading.value = true;
            getGoalChangeInfo({ workflowId }).then(async(res) => {
                if (+res.code === 0) {
                    detailDataLocal.value = res.data;
                    // eslint-disable-next-line no-unused-expressions
                    setupContext.refs.upholdHealder?.updataInitData(detailDataLocal.value);
                    goalChangeList.value = res.data.goalChangeList;
                    initQueryData.value = res.data;
                    handleCreate();
                    // 获取当前流程操作人
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipFlowId, loginName: userCode });
                } else {
                    initQueryData.value = {};
                }
            }).catch(() => {
                initQueryData.value = {};
            }).finally(() => {
                detailLoading.value = false;
            });
        };
        const isShowBtnFlow = computed(() => {
            return currentAuth.value; // 审批通过 || 当前操作人 || 流程提交人
        });
        const TIME_OUT = 500;
        const handleCreate = () => {
            if (deepRefresh.value) { // 流程分支数据改变，需要整个页面刷新（iframe标签v-if刷新、reload刷新均失效的bug）
                deepRefresh.value = false;
                ctx.$router.go(0);
                return false;
            }
            mipUrl.value = '';
            setTimeout(() => {
                mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.mipFlowId}&fdTemplateKey=CRM_goal_change&userCode=${userCode}&userName=${userName}`;
                createMetaNode();
                window.addEventListener('message', messageFunc, false);
            }, TIME_OUT);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                // const iframe = document.getElementById('myIframe');
                // iframe.contentWindow.location.reload(true);
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        // eslint-disable-next-line complexity
        const messageFunc = (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (event.data && event.data.data && event.data.success) {
                const { workflowId } = detailDataLocal.value;
                const { origin, pathname } = window.location;
                const params = event.data.data || {};
                const { tenantCode } = store.getters.currentTenant;
                params.tenantCode = tenantCode;
                // params.currentApplicationCode = this.applicationCode;
                params.currentApplicationCode = 'APP201904230047';
                if (params.formParam) {
                    // params.formParam.formInstanceId = this.$route.query.id;
                    params.formParam.formInstanceId = workflowId;
                    const { processParam } = params;
                    let isToOtherPersons = '';
                    if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                        isToOtherPersons = processParam.toOtherPersons; // 被传阅的人
                    }
                    // eslint-disable-next-line max-len
                    params.formParam.fdUrl = `${origin}${pathname}#/goalManage?workflowId=${workflowId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`; // mip代办跳转URL
                }
                // draft_submit 提交
                if (event.data.data.processParam.operationType === 'draft_submit') {
                    const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
                    if (!data) return;
                    // 比较两个数组中对象的url属性-判断是否修改了附件 但是又没有保存
                    const { changeFile } = detailDataLocal.value;
                    const diff = _.differenceWith(changeFile, initQueryData.value.changeFile, (a, b) => a.fileUrl === b.fileUrl);
                    if (diff.length > 0) {
                        return Message.warning('请先保存数据再提交流程');
                    }
                }

                btnloading.value = true;
                const tipsTimer = 3000;
                approveProcess(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('提交成功');
                        const times = setTimeout(() => {
                            ctx.$router.go(0);
                            clearTimeout(times);
                        }, tipsTimer);
                    } else {
                        Message.error(res.msg);
                    }
                }).finally(() => {
                    btnloading.value = false;
                });
            }
        };
        const deepRefresh = ref(false);
        const currentTime = ref('');
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
        };
        const saveLoading = ref(false);
        const checkLoading = ref(false);
        const tableKey = ref(false);
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            form[prop].splice(index, 1);
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'changeFile' && itemSetting.rule[0].required) {
                const targetRef = formRefs.find(item => item._props.refName === 'changeForm');
                targetRef.$refs['changeForm'].validateField(prop); // 校验附件
            }
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };
        const handleSave = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) return;

            saveLoading.value = true;
            const params = {
                ...detailDataLocal.value
            };
            saveGoalManageForm(params).then(res => {
                if (res && +res.code === 0) {
                    _initData();
                    Message.success('保存成功');
                }
            }).finally(() => {
                saveLoading.value = false;
            });
        };
        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl });
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'changeFile') {
                    if (itemSetting.rule[0].required) {
                        const targetRef = formRefs.find(item => item._props.refName === 'changeForm');
                        targetRef.$refs['changeForm'].validateField(prop);
                    }
                    detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
                }
            }
        };
        onMounted(async() => {
            _initData();
        });
        onActivated(() => {
            tableKey.value = !tableKey.value;
        });
        return {
            config,
            COLLAPSE,
            detailLoading,
            btnloading,
            detailDataLocal,
            mipUrl,
            submitMip,
            goalChangeList,
            activeCollapses,
            tableHeight,
            tableKey,
            saveLoading,
            checkLoading,
            lodash,
            handleDeleteFile,
            handlePreview,
            goalManageShow,
            handleSave,
            upLoadData,
            isShowBtnFlow
        };
    }
};
</script>
<style lang="less">
@scrollbarThumbColor: rgba(0,0,0, .2);
@scrollbarThumbColorHover: rgba(0,0,0, .4);

.mip-iframe {
    overflow: scroll;
    width: 100%;
    height: 100%;
    .goal-manage-detail {
         width: 100%;
         height: 100%;
            .header-box {
            width: 100%;
            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
                // border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;
            }
        }
        .header-part {
            height: 32px;
            .apply-info {
                float: right;
                font-size: 14px;
                line-height: 20px;
                color: #606266;
            }
        }
        .upload-demo {
            display: inline-block;
        }
        .down-mould-btn {
            margin-left: 5px;
        }
        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }
        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;
            .file-list {
                width: 100%;
                padding: 2px 0 2px 4px;
                display: flex;
                // justify-content: space-between;
                .file-name {
                    // flex: 1;
                    width: 500px;
                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }
                .view-btn, .delete-btn {
                    width: 200px;
                    display: flex;
                    a {
                        text-decoration: none;
                        color: #4285F5;
                    }
                    .el-button {
                        margin-left: 10px;
                    }
                    .el-button:focus,.el-button:hover, .el-button:active,.el-button.is-disabled{
                        outline: none !important;
                        border-color: transparent !important; /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
            }
        }
        .el-collapse-item__content {
            padding-bottom: 0;
        }
        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }
        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }
    }
    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }
    .detail-toolBar {
        height: 28px;
        .item-flow-right {
            float: right;
            &.refresh {
                margin-left: 10px;
            }
        }
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }
    .file-info {
        .el-collapse-item__header {
            background-color: #edeff6;
            padding-left: 5px;
            font-size: 14px;
            font-weight: 600;
        }
        ::-webkit-scrollbar {
            width:8px;
            height:6px;
        }
        // 滚动块样式
        ::-webkit-scrollbar-thumb {
            background-color:@scrollbarThumbColor;
        }
        ::-webkit-scrollbar-thumb:hover {
            background-color:@scrollbarThumbColorHover;
        }
    }
    .header-operation {
        margin-top: 10px;
    }
}
.no-auth {
    font-size: 16px;
}
</style>
